import { useState, forwardRef, useEffect } from "react";
import IconDate from "../../../../revampComponents/Atom/Icons/IconDate.svg";
import moment from "moment";
import { calendarReadableData, convertToDateObj } from "../../../../Utils/helpers";
import { CustomModal } from "../../../../revampComponents/Atom/Modals";
import FormButtons from "../../../../revampComponents/Molecule/Buttons/FormButtons";
import { DatePicker, RainbowThemeContainer } from "react-rainbow-components";

const CustomDateRangeModal = forwardRef(({
  isOpen,
  onClose,
  onProceed,
  initialStartDate = null,
  initialEndDate = null,
  timeZone = "UTC"
}, ref) => {
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [datesObj, setDatesObj] = useState({
    start_date: null,
    end_date: null
  });
  const theme = {
    rainbow: {
      palette: {
        brand: "#002E6E"
      }
    }
  };
  useEffect(() => {
    if (isOpen) {
      const startDateFormatted = initialStartDate ? calendarReadableData(initialStartDate) : null;
      const endDateFormatted = initialEndDate ? calendarReadableData(initialEndDate) : null;

      setStartDate(startDateFormatted);
      setEndDate(endDateFormatted);
      setDatesObj({
        start_date: initialStartDate,
        end_date: initialEndDate
      });
    }
  }, [isOpen, initialStartDate, initialEndDate]);

  const resetDates = () => {
    setStartDate(null);
    setEndDate(null);
    setDatesObj({
      start_date: null,
      end_date: null
    });
  };

  const handleClose = () => {
    resetDates();
    onClose();
  };

  const handleProceed = () => {
    const formattedDates = {
      startDate: moment(startDate).format("YYYY-MM-DDTHH:mm:ss"),
      endDate: moment(endDate).format("YYYY-MM-DDTHH:mm:ss"),
      startDateRaw: startDate,
      endDateRaw: endDate
    };
    onProceed(formattedDates);
    onClose();
  };


  const handleStartDateChange = (date) => {
    const formattedDateTime = moment(date).format("YYYY-MM-DDTHH:mm:ss");
    setDatesObj(prevState => ({
      ...prevState,
      start_date: formattedDateTime
    }));
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    const formattedDateTime = moment(date).format("YYYY-MM-DDTHH:mm:ss");
    setDatesObj(prevState => ({
      ...prevState,
      end_date: formattedDateTime
    }));
    setEndDate(date);
  };

  return (
    <div>
      <CustomModal
        ref={ref}
        openModal={isOpen}
        setOpenModal={onClose}
        floatingCancelButton="Close"
        header="Select Custom Date"
        overflow={true}
        onClose={handleClose}
        width="55%"
        content={(
          <>
            <div id="report-date-picker" className="d-flex justify-content-between report-date-picker">
              <div className="col-6 pl-3 pr-2">
                <label className="label" htmlFor="start_date">
                  Start Date
                  <span className="text text-danger"> *</span>
                </label>
                 <RainbowThemeContainer
                  theme={theme}
                  className="rainbow-align-content_center rainbow-m-vertical_large rainbow-p-horizontal_small rainbow-m_auto"
                >
                  <DatePicker
                    locale="en-IN"
                    id="start_date"
                    name="start_date"
                    formatStyle="medium"
                    value={convertToDateObj(startDate)}
                    className="calendarCus"
                    // minDate={startDate}
                    maxDate={new Date()}
                    icon={<img src={IconDate} alt="Calendar" />}
                    hideLabel={true}
                    okLabel="Save"
                    onChange={handleStartDateChange}
                  />
                </RainbowThemeContainer>
              </div>
              <div className="col-6 pl-2">
                <label className="label" htmlFor="end_date">
                  End Date
                  <span className="text text-danger"> *</span>
                </label>
                <RainbowThemeContainer
                  theme={theme}
                  className="rainbow-align-content_center rainbow-m-vertical_large rainbow-p-horizontal_small rainbow-m_auto"
                >
                  <DatePicker
                    locale="en-IN"
                    id="end_date"
                    name="end_date"
                    formatStyle="medium"
                    value={convertToDateObj(endDate)}
                    className="calendarCus"
                    minDate={startDate}
                    maxDate={new Date()}
                    icon={<img src={IconDate} alt="Calendar" />}
                    hideLabel={true}
                    okLabel="Save"
                    onChange={handleEndDateChange}
                  />
                </RainbowThemeContainer> 
              </div>
            </div>

            <div className="pt-4 pr-3">
              <FormButtons
                saveBtnContent="Proceed"
                saveBtnDisabled={!startDate || !endDate}
                cancelBtnContent="Cancel"
                onSave={(event) => {
                  event?.nativeEvent?.stopImmediatePropagation();
                  event?.preventDefault();
                  event?.stopPropagation();
                  handleProceed();
                }}
                onCancel={(event) => {
                  event?.nativeEvent?.stopImmediatePropagation();
                  event?.preventDefault();
                  event?.stopPropagation();
                  handleClose();
                }}
              />
            </div>

            <style jsx>
              {`
                .formTitle{
                  padding-left: 0px;
                }
                .react-calendar{
                  margin-bottom: 20px;
                }

                /* Prevent clipping */
                .date-picker-wrapper {
                  position: relative;
                }

                .react-calendar {
                  position: absolute !important;
                  top: 100% !important;
                  left: 0 !important;
                  z-index: 9999 !important;
                }

                /* Ensure left date picker is aligned properly */
                .col-6:first-child .react-calendar {
                  left: 0 !important;
                  right: auto !important;
                }

                .react-date-picker__calendar {
                  position: absolute !important;
                  z-index: 9999 !important;
                  left: 0 !important;
                  transform: translateX(-5%);
                }
                
                .end-date-picker .react-date-picker__calendar {
                  position: absolute !important;
                  z-index: 9999 !important;
                  left: 0 !important;
                  transform: translateX(-25%);
                }
              #report-date-picker  .react-date-picker__inputGroup__divider {
                      padding: 3px 4px;
                      white-space: pre;
                  }
             #report-date-picker   .react-date-picker__inputGroup__input { 
                      border: 0 !important;
                  }
                  
               #report-date-picker    .react-date-picker__inputGroup {
                        align-items: center;
                        display: flex;
                    }
                .ReactModal__Content{
                  transition: height 0.3s ease-in-out;
                  height: ${isDatePickerOpen ? "500px" : "auto"} !important;
                }
                
                @media screen and (max-width: 768px){
                  .ReactModal__Content{
                    width: 80%!important;
                  }
                }
                
                @media screen and (min-width: 768px) and (max-width: 982px){
                  .ReactModal__Content{
                    width: 60%!important;
                  }
                }
              `}
            </style>
          </>
        )}
      />
    </div>
  );
});

export default CustomDateRangeModal;
